import Box from "@mui/material/Box";

const Logo = () => {
    return (
        <Box
            component="img"
            sx={{
                width: "80%",
                marginX: "auto",
                marginY: 1,
            }}
            alt="Geloma"
            src={process.env.REACT_APP_SUPABASE_URL + "/storage/v1/object/public/assets/logo.png"}
        />
    )
}

export default Logo;
